import { render, staticRenderFns } from "./StreamDetails.vue?vue&type=template&id=32fdcd2a&"
import script from "./StreamDetails.vue?vue&type=script&lang=js&"
export * from "./StreamDetails.vue?vue&type=script&lang=js&"
import style0 from "./StreamDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports